<script setup lang="ts">
import type { ProgressRootProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { computed } from "vue"
import { reactiveOmit } from "@vueuse/core"
import {
  ProgressIndicator,
  ProgressRoot,

} from "reka-ui"
import { cn } from '@/shadcn/lib/utils'

const props = withDefaults(
  defineProps<ProgressRootProps & { class?: HTMLAttributes["class"] }>(),
  {
    modelValue: 0,
    max: 100,
  },
)

// Create a computed property to calculate the percentage
const percentage = computed(() => {
  if (props.max === 0) return 0; // Prevent division by zero
  return Math.round(Math.min((props.modelValue ?? 0) / props.max * 100, 100));
});

const delegatedProps = reactiveOmit(props, "class")
</script>

<template>
  <ProgressRoot
    v-bind="delegatedProps"
    :class="
      cn(
        'tw:relative tw:h-1 tw:w-full tw:overflow-hidden tw:rounded-full tw:bg-secondary',
        props.class,
      )
    "
  >
    <ProgressIndicator
      :class="[
        'tw:h-full tw:w-full tw:flex-1 tw:transition-all',
        percentage < 60 ? 'tw:bg-green-500' : '',
        percentage >= 60 && percentage < 80 ? 'tw:bg-yellow-500' : '',
        percentage >= 80 && percentage !== 100 ? 'tw:bg-orange-500' : '',
        percentage >= 100 ? 'tw:bg-red-500' : '',
      ]"
      :style="`transform: translateX(-${100 - (percentage ?? 0)}%);`"
    />
  </ProgressRoot>
</template>